import { MIN_AGE } from '@/forms/constants/onboarding-logic';

const getFormatedBornDate = (date) => {
  const year = date.slice(0, 2);
  const month = date.slice(2, 4);
  const day = date.slice(4, 6);

  const currentYearLastTwoDigits = parseInt(new Date().getFullYear().toString().substr(-2), 10);
  const yearsInt = parseInt(year, 10);
  let yearFirstDigits = '19';

  if (yearsInt <= currentYearLastTwoDigits - MIN_AGE) {
    yearFirstDigits = '20';
  }

  return `${yearFirstDigits}${year}-${month}-${day}`;
};

export default getFormatedBornDate;
